import { render, staticRenderFns } from "./AkbsMinWageTable.vue?vue&type=template&id=c31c1ebe&scoped=true&"
import script from "./AkbsMinWageTable.vue?vue&type=script&lang=js&"
export * from "./AkbsMinWageTable.vue?vue&type=script&lang=js&"
import style0 from "./AkbsMinWageTable.vue?vue&type=style&index=0&id=c31c1ebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31c1ebe",
  null
  
)

export default component.exports